// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.reportfooter[data-v-2eb44c67]{\n  width: 100%;\n  /*margin: 0 auto;*/\n  margin-top: 3%;\n}\n.logo[data-v-2eb44c67]{\n  padding: 18px 42px 0 42px;\n  font-size: 30px;\n  color: white;\n  line-height: 35px;\n  text-align: center;\n}\n\n", ""]);
// Exports
module.exports = exports;
